export default "__VITE_ASSET__wbv6vldE__"